<template>
  <div>
    <div id="invoice-page">
      <vx-card id="invoice-container">
        <div class="vx-row leading-loose p-base">
          <div class="vx-col w-1/2 mt-12">
            <h1>SeedSuite</h1>
            <div class="invoice__invoice-detail mt-6">
              <h6>INVOICE NO.</h6>
              <p>{{ sale.sales_code }}</p>
              <h6 class="mt-4">INVOICE DATE</h6>
              <p>{{ formatDate(sale.sales_date) }}</p>
            </div>
            <div class="invoice__recipient-info my-4">
              <h5>Customer Details</h5>
              <p>{{ sale.customer && sale.customer.business_name }}</p>
              <p>{{ sale.customer && sale.customer.address }}</p>
              <p>Customers License: {{ sale.customer && sale.customer.license_number }}</p>
              <p>Invoice #{{ sale.sales_code }}</p>
              <p>Sales Status :Final</p>
              <p>Reference No. :</p>
            </div>
          </div>
        </div>
        <!-- INVOICE CONTENT -->
        <div class="p-base">
          <div class="float-right m-2">
            <vs-button class="mr-2 vs-con-loading__container" @click="printExitLables" id="add-inventory-button" type="relief">Exit Label</vs-button>
          </div>
          <!-- INVOICE TASKS TABLE -->
          <vs-table hoverFlat :data="saleReturn">
            <!-- HEADER -->
            <template slot="thead" class="text-center">
              <vs-th></vs-th>
              <vs-th class="pointer-events-none">Item Name </vs-th>
              <vs-th class="pointer-events-none">Unit Price </vs-th>
              <vs-th class="pointer-events-none">Quantity</vs-th>
              <vs-th class="pointer-events-none">Discount Amount </vs-th>
              <vs-th class="pointer-events-none">Tax </vs-th>
              <vs-th class="pointer-events-none">Total Amount </vs-th>
              <vs-th class="pointer-events-none">Exit Label </vs-th>
            </template>
            <!-- DATA -->
            <template slot-scope="{ data }" class="text-center">
              <vs-tr :key="i" v-for="(tr, i) in data">
                <vs-td><vs-checkbox v-model="selectedProducts" :vs-value="tr.product.id"></vs-checkbox></vs-td>
                <vs-td>{{ tr.product_name }} </vs-td>
                <vs-td>$ {{ tr.price_per_unit | currencyFilter }} </vs-td>
                <vs-td>{{ tr.sales_qty | weightFilter }}</vs-td>
                <vs-td>$ {{ tr.tot_discount | currencyFilter }}</vs-td>
                <vs-td>$ {{ tr.tot_taxes_amt | currencyFilter }}</vs-td>
                <vs-td>$ {{ tr.tot_price | currencyFilter }}</vs-td>
                <vs-td>
                  <div class="inline-flex">
                    <vx-tooltip text="Print Exit Label"> <feather-icon icon="PrinterIcon" svgClasses="h-5 w-5 hover:text-primary cursor-pointer" @click="printExitLable(tr)" /> </vx-tooltip>
                  </div>
                </vs-td>
              </vs-tr>

              <vs-tr>
                <vs-td></vs-td>
                <vs-td class="text-center">Total</vs-td>
                <vs-td></vs-td>
                <vs-td>{{ invoice_items_qty_count | weightFilter }}</vs-td>
                <vs-td>$ {{ invoice_items_total_dicount | currencyFilter }}</vs-td>
                <vs-td>$ {{ invoice_items_total_tax | currencyFilter }} </vs-td>
                <vs-td>$ {{ invoice_items_sub_total | currencyFilter }}</vs-td>
                <vs-td></vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>

        <div class="vx-row mt-10">
          <!-- invoice payment and note detail -->
          <div class="vx-col w-full lg:w-3/5 md:w-2/3">
            <!-- Invoice Note -->
            <div class="invoice__note p-5"></div>
            <!-- payment informations -->
            <div class="payment__informations">
              <p class="mt-2 mb-3 ml-3">Payments Information :</p>
              <vs-table hoverFlat :data="salesPayments">
                <template slot="thead">
                  <vs-th class="pointer-events-none">Date </vs-th>
                  <vs-th class="pointer-events-none">Payment Type </vs-th>
                  <vs-th class="pointer-events-none">Payment Note </vs-th>
                  <vs-th class="pointer-events-none">Payment </vs-th>
                </template>
                <template slot-scope="{ data }">
                  <vs-tr :key="i" v-for="(tr, i) in data">
                    <vs-td>{{ formatDate(tr.payment_date) }}</vs-td>
                    <vs-td>{{ tr.payment_type }}</vs-td>
                    <vs-td>{{ tr.payment_note }}</vs-td>
                    <vs-td>$ {{ tr.payment_amount | currencyFilter }}</vs-td>
                  </vs-tr>
                  <vs-tr>
                    <vs-td></vs-td>
                    <vs-td></vs-td>
                    <vs-td>Total</vs-td>
                    <vs-td>$ {{ payments_sub_total | currencyFilter }}</vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </div>

          <!-- invoice total detail -->
          <div class="vx-col w-full lg:w-2/5 md:w-2/3">
            <!-- checkout details -->
            <div class="checkout__details">
              <div class="checkout_details p-1">
                <!-- note -->
                <div class="vx-row p-3">
                  <div class="vx-col w-1/2 font-bold text-right">Note</div>
                  <div class="vx-col w-1/2 font-bold">{{ sale.tot_discount_amt | currencyFilter }}</div>
                </div>

                <!-- subtotal = price * qty -->
                <div class="vx-row p-3">
                  <div class="vx-col w-1/2 font-bold text-right">Subtotal</div>
                  <div class="vx-col w-1/2 font-bold">$ {{ invoice_items_sub_total | currencyFilter }}</div>
                </div>

                <!-- discount - all product discount sum -->
                <div class="vx-row p-3">
                  <div class="vx-col w-1/2 font-bold text-right">Discount on All</div>
                  <div class="vx-col w-1/2 font-bold">$ {{ invoice_items_total_dicount | currencyFilter }}</div>
                </div>

                <!-- city tax - all product city tax sum -->
                <div class="vx-row p-3" v-if="invoice_items_total_count_tax('city_tax_amt') > 0">
                  <div class="vx-col w-1/2 font-bold text-right">City Tax</div>
                  <div class="vx-col w-1/2 font-bold">$ {{ invoice_items_total_count_tax('city_tax_amt') | currencyFilter }}</div>
                </div>

                <!-- state tax - all product state tax sum -->
                <div class="vx-row p-3" v-if="invoice_items_total_count_tax('state_tax_amt') > 0">
                  <div class="vx-col w-1/2 font-bold text-right">State Tax</div>
                  <div class="vx-col w-1/2 font-bold">$ {{ invoice_items_total_count_tax('state_tax_amt') | currencyFilter }}</div>
                </div>

                <!-- excise tax - all product excise tax sum -->
                <div class="vx-row p-3" v-if="invoice_items_total_count_tax('excise_tax_amt') > 0">
                  <div class="vx-col w-1/2 font-bold text-right">Excise Tax</div>
                  <div class="vx-col w-1/2 font-bold">$ {{ invoice_items_total_count_tax('excise_tax_amt') | currencyFilter }}</div>
                </div>

                <!-- county tax - all product county tax sum -->
                <div class="vx-row p-3" v-if="invoice_items_total_count_tax('county_tax_amt') > 0">
                  <div class="vx-col w-1/2 font-bold text-right">County Tax</div>
                  <div class="vx-col w-1/2 font-bold">$ {{ invoice_items_total_count_tax('county_tax_amt') | currencyFilter }}</div>
                </div>

                <!-- total tax of invoice -->
                <div class="vx-row p-3">
                  <div class="vx-col w-1/2 font-bold text-right">Tax</div>
                  <div class="vx-col w-1/2 font-bold">$ {{ invoice_items_total_tax | currencyFilter }}</div>
                </div>

                <!-- redeem amount of invoice -->
                <div class="vx-row p-3" v-if="Math.round(invoiceRedeemAmount)">
                  <div class="vx-col w-1/2 font-bold text-right">Redeem Amount</div>
                  <div class="vx-col w-1/2 font-bold">$ {{ invoiceRedeemAmount | currencyFilter }}</div>
                </div>

                <!-- grand total -->
                <div class="vx-row p-3">
                  <div class="vx-col w-1/2 font-bold text-right">Grand Total</div>
                  <div class="vx-col w-1/2 font-bold">$ {{ invoice_grand_total | currencyFilter }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Print Invoice Popup -->
        <vs-popup id="print-invoice" class="text-center" title="Print Label" button-accept="false" button-cancel="false" :active.sync="showModal">
          <hr style="background: lightgrey" />
          <div class="vx-row mt-3">
            <div class="vx-col w-full">
              <div class="vx-col md:w-2/4 px-8">
                <div class="vx-row mb-2">
                  <vs-input icon="icon icon-list" type="number" v-model="form.total_label" icon-pack="feather" class="w-full" label="Total Label" name="Total Label" v-validate="'required'" />
                  <span class="text-danger text-center text-sm" v-show="errors.has('Total Label')">{{ errors.first('Total Label') }}</span>
                </div>
              </div>
              <div class="float-center">
                <vs-button class="mr-2 vs-con-loading__container" @click="downloadPrint" id="add-inventory-button" type="relief">Download Label</vs-button>
              </div>
            </div>
          </div>
        </vs-popup>
        <!-- End Print Invoice Popup -->

        <!-- INVOICE FOOTER -->
        <div class="vx-row">
          <div class="vx-col w-full">
            <div class="mt-8" vs-align="center" vs-type="flex" vs-justify="center">
              <vs-button class="mr-2 vs-con-loading__container" @click="printSaleInvoice" id="add-inventory-button" type="relief">POS Invoice</vs-button>
              <vs-button v-if="checkPermissionByIds([permissions.SALE_RETURN_VIEW])" color="danger" type="relief" class="text-left" @click="invoiceSalesReturn">Sales Return</vs-button>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import { dateMixins } from '@/mixins/dateMixins.js'
import { paymentMixins } from '@/utils/paymentTypes'
import { weightMixins } from '@/utils/weightType'
import { taxMode, discountApplicableType } from '@/utils/enums'

export default {
  name: 'InvoiceView',

  data() {
    return {
      saleDetails: null,
      saleReturn: [],
      showModal: false,
      productIds: [],
      selectedProducts: [],
      saleId: this.$route.params.id,
      form: {
        total_label: null
      }
    }
  },

  mixins: [weightMixins, paymentMixins, dateMixins],

  async mounted() {
    // get sale records
    await this.getSaleById(this.$route.params.id)

    this.saleDetails = { ...this.sale, sales_return_date: new Date(), return_note: '' }
    this.saleReturn = this.salesItems.map((item) => ({
      ...item,
      return_qty: 0
    }))

    if (this.saleDetails) {
      await this.managesalesReturnData()
    }
  },

  computed: {
    ...mapState('pos', ['loading', 'sale', 'salesItems', 'salesPayments']),

    invoice_items_price_total() {
      return this.saleReturn.reduce((acc, item) => acc + item.price_per_unit * item.sales_qty, 0)
    },

    invoice_items_qty_count() {
      return this.saleReturn.reduce((acc, item) => acc + item.sales_qty, 0)
    },

    invoice_items_total_dicount() {
      return this.saleReturn.reduce((acc, item) => acc + item.tot_discount, 0)
    },

    invoice_items_total_count_tax() {
      return (type) => this.saleReturn.reduce((acc, item) => acc + item[type], 0)
    },

    invoice_items_total_tax() {
      return this.saleReturn.reduce((acc, item) => acc + item.tot_taxes_amt, 0)
    },

    invoice_items_sub_total() {
      // eslint-disable-next-line no-mixed-operators
      return this.saleReturn.reduce((acc, item) => acc + item.tot_price, 0)
    },

    invoiceRedeemAmount() {
      return this.saleReturn.reduce((acc, item) => acc + item.redeem_dollar, 0)
    },

    invoice_grand_total() {
      return this.invoice_items_sub_total + this.invoice_items_total_tax
    },

    payments_sub_total() {
      return this.salesPayments.reduce((acc, item) => acc + item.payment_amount, 0)
    }
  },

  methods: {
    ...mapActions('pos', { getSaleById: 'getSaleById' }),
    ...mapMutations('pos', ['SET_STATE']),
    ...mapState('permission', ['permissions']),
    ...mapGetters('auth', ['checkPermissionByIds']),

    // manage sales return data
    async managesalesReturnData() {
      // if no record foun for previous sale return then do nothing
      if (!this.saleDetails.sales_return) {
        return null
      }

      this.saleDetails.sales_return.salesItemsReturn.forEach((element) => {
        const tempElementIndex = this.saleReturn.findIndex((elem) => elem.productId === element.productId)

        if (tempElementIndex > -1) {
          const tempSubTotal = this.saleReturn[tempElementIndex].sales_qty - element.return_qty

          this.saleReturn[tempElementIndex].city_tax_amt = (tempSubTotal * this.saleReturn[tempElementIndex].city_tax_amt) / this.saleReturn[tempElementIndex].sales_qty // city tax
          this.saleReturn[tempElementIndex].county_tax_amt = (tempSubTotal * this.saleReturn[tempElementIndex].county_tax_amt) / this.saleReturn[tempElementIndex].sales_qty // county tax
          this.saleReturn[tempElementIndex].excise_tax_amt = (tempSubTotal * this.saleReturn[tempElementIndex].excise_tax_amt) / this.saleReturn[tempElementIndex].sales_qty // exxcise tax
          this.saleReturn[tempElementIndex].state_tax_amt = (tempSubTotal * this.saleReturn[tempElementIndex].state_tax_amt) / this.saleReturn[tempElementIndex].sales_qty // state tax
          this.saleReturn[tempElementIndex].tot_taxes_amt = (tempSubTotal * this.saleReturn[tempElementIndex].tot_taxes_amt) / this.saleReturn[tempElementIndex].sales_qty // product total tax
          this.saleReturn[tempElementIndex].tot_discount = (tempSubTotal * this.saleReturn[tempElementIndex].tot_discount) / this.saleReturn[tempElementIndex].sales_qty // product discount
          this.saleReturn[tempElementIndex].sales_qty = this.saleReturn[tempElementIndex].sales_qty - element.return_qty // product quantity

          this.saleReturn[tempElementIndex].tot_price = Math.max(
            0,
            this.saleReturn[tempElementIndex].tot_price - this.calculateReturnItemPrice(this.saleReturn[tempElementIndex], element.return_qty, element.discount_amount)
          ) // product total)
        }
      })
    },

    // print single product label
    printExitLable(tr) {
      this.showModal = true
      this.productIds.push(tr.product.id)
    },

    // print multiple product label
    printExitLables() {
      this.showModal = true
      this.productIds.push(...this.selectedProducts)
    },

    // print labels
    async downloadPrint() {
      if (!(await this.$validator.validate())) {
        //show message
        return false
      }

      const routeData = this.$router.resolve({
        name: 'pos-exit-print',
        params: {
          saleId: this.saleId,
          number: this.form.total_label,
          productIds: this.productIds.join('-')
        }
      })
      window.open(routeData.href, '_blank')
    },

    // print sales invoice
    async printSaleInvoice() {
      const routeData = this.$router.resolve({
        name: 'sale-invoice-print',
        params: {
          saleId: this.saleId
        }
      })
      window.open(routeData.href, '_blank')
    },

    // invoice sale return
    invoiceSalesReturn() {
      this.$router.push(`/pos/edit/sales-return/${this.$route.params.id}`)
    },

    // calculate return item price
    calculateReturnItemPrice(item, returnQty, discountAmount) {
      if (this.sale.tax_mode === taxMode.taxIncluded && item.discount_amount_type === discountApplicableType.postTax) {
        return (item.product.sales_price * returnQty - discountAmount) / (1 + item.total_tax_percentage / 100)
      } else {
        return item.price_per_unit * returnQty - discountAmount
      }
    }
  },

  filters: {
    // currencyFilter rounded to 2 point
    currencyFilter(value) {
      return paymentMixins.methods.mathRound(value, 2)
    },

    //weightFilter rounded conversation
    weightFilter(value) {
      return weightMixins.methods.mathRound(value, 3)
    }
  },

  beforeRouteLeave(_, __, next) {
    this.showModal = false
    next()
  }
}
</script>
